class MapLocationPageController {

  constructor(LocationService, AlertService, LoaderService) {
    this.LocationService = LocationService;
    this.AlertService = AlertService;
    this.LoaderService = LoaderService;
  }

  $onInit() {
    var self = this;
    self.adverts = [];
    // self.LoaderService.start();
    // self.LocationService.getAll()
    //     .then( (locations)=> self.locations = locations )
    //     .catch( (error)=> self.AlertService.error("There was a problem getting the Locations") )
    //     .finally( () => self.LoaderService.stop() );
  }

}
MapLocationPageController.$inject =  ['LocationService', 'AlertService', 'LoaderService'];
export default MapLocationPageController;